/**
 * One corner length: `0`, or a non-negative number with one of the units the
 * Core themes use for rounding. Deliberately small, like the colour notations:
 * `var()` and `calc()` cannot be evaluated here, and a value the browser drops
 * leaves the element untouched while the app reads back a success.
 */
const LENGTH = /^(0|(\d+(\.\d+)?|\.\d+)(px|rem|em|%))$/;

/** True when `input` is one to four corner lengths, space-separated. */
export function isBorderRadius(input: string): boolean {
	const lengths = input.trim().split(/\s+/);
	return (
		lengths.length >= 1 &&
		lengths.length <= 4 &&
		lengths.every((length) => LENGTH.test(length))
	);
}

/**
 * Why `input` cannot be used as a corner radius, or `null` when it can.
 *
 * The accepted shape is named in the reason because the app only ever sees
 * this sentence.
 */
export function borderRadiusRefusal(input: string): string | null {
	if (isBorderRadius(input)) return null;
	return `"${input}" is not a corner radius; use one to four lengths in px, rem, em or %, or 0`;
}
